var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2918 0.500885C5.50194 0.500885 0.792236 5.21058 0.792236 11.0005C0.792236 16.7903 5.50194 21.5 11.2918 21.5C17.0817 21.5 21.7914 16.7903 21.7914 11.0005C21.7914 5.21058 17.0817 0.500885 11.2918 0.500885ZM10.5419 4.25071H12.0418V10.2505H18.0416V11.7504H10.5419V4.25071Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDuration);
export default __webpack_public_path__ + "static/media/TimeDuration.92831ec311e129e43e1408eab5217c77.svg";
export { ForwardRef as ReactComponent };